<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "GraphVariants" });
export let sizes = [];
const COLUMN_WIDTH = 10;
const COLUMN_GAP = 4;
const TEXT_HEIGHT = 7;
const HEIGHT = 40;
const UNIT = COLUMN_WIDTH + COLUMN_GAP;
const getLastSizeIndex = (sizes2) => {
    if (!Array.isArray(sizes2) || sizes2.length === 0) {
        return -1;
    }
    return sizes2.map((size) => size.quantity > 0).lastIndexOf(true);
};
const getFirstSizeIndex = (sizes2) => {
    if (!Array.isArray(sizes2) || sizes2.length === 0) {
        return -1;
    }
    return sizes2.findIndex((size) => size.quantity > 0);
};
const trimSize = (size) => {
    const VALUE = size.dimension.value.replace("EU", "").replace("US", "").replace(" ", "").replace(/\.0$/u, "").trim();
    return {
        ...size,
        dimension: {
            ...size.dimension,
            value: VALUE.length > 4 ? `${VALUE.slice(0, 3).replace(/[/-]+$/u, "")}` : VALUE
        }
    };
};
$: SIZES = sizes.slice(getFirstSizeIndex(sizes), getLastSizeIndex(sizes) + 1).map(trimSize);
$: WIDTH = UNIT * SIZES.length + COLUMN_GAP;
$: MAX_QUANTITY = Math.max(...sizes.map((size) => size.quantity || 0));
const getX = (index) => UNIT * index + COLUMN_GAP;
const getHeight = (size) => {
    if (!size.quantity) {
        return 0;
    }
    return Math.round(size.quantity / MAX_QUANTITY * (HEIGHT - TEXT_HEIGHT));
};
const getFontSize = (count) => {
    if (count < 3) {
        return "7px";
    }
    if (count < 5) {
        return "6px";
    }
    if (count < 7) {
        return "4px";
    }
    return "3px";
};
</script>

{#if SIZES.length > 0}
    <svg
        width = { WIDTH }
        height = { HEIGHT }
        viewBox = '0 0 { WIDTH } { HEIGHT }'
    >
        {#each SIZES as size, index}
            <rect
                x = { getX(index) }
                y = { HEIGHT - getHeight(size) - TEXT_HEIGHT }
                width = { COLUMN_WIDTH }
                height = { getHeight(size) }
                style = 'fill:rgba(193, 192, 189, 0.4)'
                rx = '2'
            />
            <text
                x = { getX(index) + (COLUMN_WIDTH / 2) }
                y = { HEIGHT }
                style = { `font-size: ${ getFontSize(size.dimension.value.length) }` }
                width = { COLUMN_WIDTH + (COLUMN_GAP / 2) }
                height = '5px'
                text-anchor = 'middle'
            >
                {#if size.quantity > 0}
                    { size.dimension.value }
                {/if}
            </text>
        {/each}
    </svg>
{/if}